import React from 'react';
import Image from 'material-ui-image';
import {
  StudioCanvasOverlay,
  StudioCanvasOverlayProps,
} from '../../../../../base-components/StudioOverlay/StudioCanvasOverlay';
import {
  ImageMetadata,
  useStudioImageMetaData,
} from '../../../../../base-components/StudioImageMetaData';
import './ImageOverlay.scss';
import {Skeleton} from '../../../../Skeleton';

export type ImageOverlayProps = {
  image: string;
  filename?: string;
  size: number;
  width: number;
  height: number;
  highlightIndex?: number | null;
} & StudioCanvasOverlayProps;

const getScaleFactor = (from: number, to: number) => to / from;

export function ImageOverlay({
  image: url,
  filename,
  width: imageWidth,
  height: imageHeight,
  size = 300,
  highlightIndex,
  data,
  ...rest
}: ImageOverlayProps) {
  const metaData: ImageMetadata = useStudioImageMetaData(url);
  const {width: _Width, height: _Height} = metaData;
  const aWidth = _Width || imageWidth;
  const aHeight = _Height || imageHeight;

  // sometimes loading images from blobs so metadata is not needed
  if ((metaData.fileName || filename) && (!metaData.busy || imageWidth)) {
    const scaleX = aWidth ? getScaleFactor(aWidth, size) : 1;
    const scaleY = aHeight ? getScaleFactor(aHeight, size) : 1;
    const scaleFactor = Math.min(scaleX, scaleY);
    const width = Math.floor(scaleFactor * (aWidth || 0));
    const height = Math.floor(scaleFactor * (aHeight || 0));
    const bboxData = data.map(el => ({
      ...el,
      bbox: [
        (el.bbox?.[0] ?? 0) * (width || 0),
        (el.bbox?.[1] ?? 0) * (height || 0),
        (el.bbox?.[2] ?? 0) * (width || 0),
        (el.bbox?.[3] ?? 0) * (height || 0),
      ],
    }));
    const src = url.startsWith('blob') ? url : url + `&resolution=${width}:${height}`;
    return (
      <div className="image-overlay" style={{width, height}}>
        <>
          <Image
            src={src}
            imageStyle={{width, height}}
            loading={<Skeleton variant="rect" style={{width, height}} />}
            // width={width}
            // height={height}
          />
          <StudioCanvasOverlay
            width={width}
            height={height}
            highlightIndex={highlightIndex}
            data={bboxData}
            boxColor={'yellow'}
            showAll={true}
            selectOnMouseOver={false}
            {...rest}
          />
        </>
      </div>
    );
  }

  return <></>;
}
